import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'
import type { BadgeTone, UpboTag } from '@/types'

interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, UpboTag {
  tone?: BadgeTone
  size?: 'sm' | 'md'
  dot?: boolean
}

const tones: Record<BadgeTone, string> = {
  neutral: 'bg-surface-2 text-text-muted border-border',
  primary: 'bg-transparent text-primary border-primary',
  success: 'bg-success-soft text-success border-transparent',
  warning: 'bg-warning-soft text-warning border-transparent',
  danger: 'bg-error-soft text-error border-transparent',
  accent: 'bg-ink text-on-ink border-transparent',
}

/** Small letterspaced marker — collection tags, listing status, stock notes. */
export function Badge({ className, tone = 'neutral', size = 'md', dot, children, ...props }: BadgeProps) {
  return (
    <span
      data-upbo-type="badge"
      className={cn(
        'inline-flex items-center gap-1.5 rounded-squircle border font-medium uppercase tracking-[0.12em] whitespace-nowrap',
        size === 'sm' ? 'h-5 px-2 text-[9px]' : 'h-[24px] px-2.5 text-[10px]',
        tones[tone],
        className,
      )}
      {...props}
    >
      {dot && <span className="w-1 h-1 rounded-full bg-current" />}
      {children}
    </span>
  )
}
